import {injectable} from 'inversify';

import type {SubtenantModel} from './Subtenant.model';

import {BaseController} from '../Base/Base.controller';

@injectable()
export class SubtenantController extends BaseController<SubtenantModel> {
  constructor() {
    super();
  }
}
